/**
 * Jyotish Tarang -- supported language list.
 *
 * Display/rollout order is an explicit owner decision (14 Jul 2026, see
 * LANGUAGE_SUPPORT_PLAN.md Section 4e): Hindi first, English second, then
 * the remaining 17 languages alphabetically by English name. Do not re-sort
 * this array -- the order here IS the order shown in the language switcher.
 *
 * `builtIn` = translation.json for this language has real (non-empty)
 * content and can be selected by users, gated further by the backend's
 * `enabled_languages` tier_config key (a language can have real content
 * built but still be held back from general release via that admin flag --
 * this array only reflects "has anything been translated yet", not
 * "is it currently turned on for users").
 */
export interface LanguageDef {
  code: string;       // ISO 639-1
  englishName: string;
  nativeName: string;
  builtIn: boolean;
}

export const LANGUAGES: LanguageDef[] = [
  { code: 'hi', englishName: 'Hindi',                nativeName: 'हिन्दी',        builtIn: true  },
  { code: 'en', englishName: 'English',              nativeName: 'English',       builtIn: true  },
  { code: 'as', englishName: 'Assamese',             nativeName: 'অসমীয়া',        builtIn: true  },
  { code: 'bn', englishName: 'Bengali',              nativeName: 'বাংলা',          builtIn: true  },
  { code: 'zh', englishName: 'Chinese (Simplified)', nativeName: '简体中文',        builtIn: true  },
  { code: 'fr', englishName: 'French',               nativeName: 'Français',      builtIn: true  },
  { code: 'de', englishName: 'German',               nativeName: 'Deutsch',       builtIn: true  },
  { code: 'gu', englishName: 'Gujarati',             nativeName: 'ગુજરાતી',        builtIn: true },
  { code: 'it', englishName: 'Italian',              nativeName: 'Italiano',      builtIn: true  },
  { code: 'ja', englishName: 'Japanese',             nativeName: '日本語',          builtIn: true },
  { code: 'kn', englishName: 'Kannada',               nativeName: 'ಕನ್ನಡ',         builtIn: true  },
  { code: 'ml', englishName: 'Malayalam',            nativeName: 'മലയാളം',        builtIn: true  },
  { code: 'mr', englishName: 'Marathi',               nativeName: 'मराठी',         builtIn: true  },
  { code: 'or', englishName: 'Odia',                  nativeName: 'ଓଡ଼ିଆ',         builtIn: true  },
  { code: 'pt', englishName: 'Portuguese',            nativeName: 'Português',     builtIn: true  },
  { code: 'pa', englishName: 'Punjabi',                nativeName: 'ਪੰਜਾਬੀ',        builtIn: true  },
  { code: 'es', englishName: 'Spanish',                nativeName: 'Español',      builtIn: true  },
  { code: 'ta', englishName: 'Tamil',                  nativeName: 'தமிழ்',        builtIn: true  },
  { code: 'te', englishName: 'Telugu',                 nativeName: 'తెలుగు',       builtIn: true  },
];

export const LANGUAGE_CODES = LANGUAGES.map(l => l.code);
export const DEFAULT_LANGUAGE = 'en';
